export const InventoryMessages = {
  'en-US': {
    inventoryFilters: {
      All: 'All'
    }
    // returnsStatuses: {
    //   AwaitingArrival: 'Awaiting Arrival',
    //   Arrived: 'Arrived',
    //   Processing: 'Processing',
    //   Cancelled: 'Cancelled',
    //   Completed: 'Completed'
    // },
    // returnsStatusTooltip: {
    //   AwaitingArrival: 'Return Order is in awaiting arrival',
    //   Arrived: 'Return Order has arrived',
    //   Processing: 'Return Order is processing',
    //   Cancelled: 'Return Order is cancelled',
    //   Completed: 'Return Order is completed'
    // }
  }
}
